import { booleanAttribute, Component, input } from '@angular/core';
import { ButtonComponent } from 'app/shared/components/button/button.component';
import { Organisation } from 'app/shared/models/organisation.model';

@Component({
  selector: 'ez-contact',
  imports: [ButtonComponent],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class ContactComponent {
  readonly organisation = input.required<Organisation>();
  readonly customData = input<Record<string, string>>({});
  readonly teaser = input<string>('');
  readonly teaserShort = input<string>('');
  readonly phonePrefix = input<string>('');
  readonly subtitle = input<string>('');
  readonly withContactForm = input<boolean>(false, { transform: booleanAttribute });
  // TODO
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  openContactForm() {}
}
